export { default } from "ember-stereo/services/stereo";
